<template>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <div class="row row-space-between row-space-top">
                        <div class="col-size-auto">
                            <h2 class="subtitle">Ekstraudstyr</h2>
                        </div>
                    </div>
                    <table class="table-list">
                        <thead class="sticky-thead">
                            <tr>
                                <th>

                                </th>
                                <th>

                                </th>
                                <th v-for="group in data" :key="group.name + '_head'" class="align-right">
                                    {{ group.name }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(extraEquipment, index) in allExtraEquipment" :key="extraEquipment.equipmentCode + '_' + index">
                                <td>
                                    {{ extraEquipment.equipmentCode.substring(0, 3) }}
                                </td>
                                <td>
                                    <strong>{{ extraEquipment.name }} {{ setFormattedMandatoryEquipmentCode(extraEquipment.mandatoryAddedEquipmentCode) }}</strong>
                                    <div class="table-text-2">{{ extraEquipment.description }}</div>
                                </td>
                                <td v-for="group in data" class="align-right">
                                    <span v-html="setFormattedPrice(group.name, extraEquipment.equipmentCode, extraEquipment.name, extraEquipment.description)"></span>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="100" v-html="extraEquipTermsAndConditionsText"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="row row-space-between row-space-top">
                        <div class="col-size-auto">
                            <h2 class="subtitle">Farver</h2>
                        </div>
                    </div>
                    <table class="table-list">
                        <thead class="sticky-thead">
                            <tr>
                                <th>

                                </th>
                                <th>

                                </th>
                                <th v-for="group in colors" :key="group.name + '_head'" class="align-right">
                                    {{ group.name }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(color, index) in allColors" :key="color.colorCode + '_' + index">
                                <td>
                                    {{ color.colorCode }}
                                </td>
                                <td>
                                    <strong>{{ color.name }}</strong>
                                </td>
                                <td v-for="group in colors" :key="group.name + '_price'" class="align-right">
                                    <span v-html="setFormattedColorPrice(group.name, color.colorCode)"></span>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="100" v-html="extraEquipTermsAndConditionsText"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import formatMixin from '../mixins/formatter.js';
    import _ from 'lodash';

    export default {
        name: 'model-details-extra-equipment',
        mixins: [formatMixin],
        props: {
            data: {
                type: Array,
                default: undefined
            },
            colors: {
                type: Array,
                default: undefined
            },
            extraEquipTermsAndConditionsText: {
                type: String,
                default: undefined
            }
        },
        data() {
            return {
                sortKey: 'name'
            }
        },
        computed: {
            allExtraEquipment: function () {
                if (this.data !== undefined) {
                    let flattenExtraEquipment = _.flatMap(this.data, table => table.extraEquipment);
                    let uniqueExtraEquipment = _.uniqBy(flattenExtraEquipment, extraEquipment => extraEquipment.equipmentCode);
                    let uniqueUniqueExtraEquipment = _.uniqBy(uniqueExtraEquipment, extraEquipment => extraEquipment.description + '|' + extraEquipment.name);
                    let extraEquipmentList = _.orderBy(uniqueUniqueExtraEquipment, this.$data.sortKey, 'asc');

                    return extraEquipmentList;
                }

                return [];
            },
            allColors: function () {
                if (this.colors !== undefined) {
                    let flattenColors = _.flatMap(this.colors, table => table.colors);
                    let uniqueColors = _.uniqBy(flattenColors, colors => colors.name);
                    let colorsList = _.orderBy(uniqueColors, this.$data.sortKey, 'asc');

                    return colorsList;
                }
            }
        },
        methods: {
            setFormattedMandatoryEquipmentCode: function (equipmentCode) {
                if (equipmentCode !== undefined && equipmentCode !== null && equipmentCode !== '') {
                    return `(${equipmentCode})`;
                }

                return '';
            },
            setFormattedPrice: function (groupName, equipmentCode, equipmentName, equipmentDescription) {
                if (this.$props.data !== undefined) {
                    let extraEquipmentGroup = this.$props.data.find(group => group.name === groupName);
                    let equipment = extraEquipmentGroup.extraEquipment.filter(equipment => equipment.name === equipmentName && equipment.description === equipmentDescription)[0];

                    if (equipment === undefined) {
                        return '-';
                    }

                    if (equipment.priceIncludedVat === '0') {
                        return '0 kr.';
                    }
                    if (equipment.priceIncludedVat == null) {
                        return '<span style="font-size: large; color: green; ">&#10004;</span>';
                    }

                    let price = this.formatThousand(equipment.priceIncludedVat);

                    return price + ' kr.';
                }

                return '-';
            },
            setFormattedColorPrice: function (groupName, colorCode) {
                if (this.$props.colors !== undefined) {
                    let colorGroup = this.$props.colors.find(group => group.name == groupName);
                    let color = colorGroup.colors.filter(color => color.colorCode === colorCode)[0];

                    if (color === undefined) {
                        return '-';
                    }

                    if (color.priceIncludedVat === '0') {
                        return '0 kr.';
                    }
                    if (color.priceIncludedVat == null) {
                        return '<span style="font-size: large; color: green; ">&#10004;</span>';
                    }

                    let price = this.formatThousand(color.priceIncludedVat);

                    return price + ' kr.';
                }

                return '-';
            }
        }
    }
</script>